module.exports = __webpack_public_path__ + "static/media/harmac.a44e60c0.png";